import Component from '@component';
import Slide from '@core/Slide.js';
import emitter from '@utils/Emitter.js';
import {getFocusables} from '@utils/ally/index.js';

export default class Expandable extends Component {
	static selectors = {
		el: '[data-component="expandable"]',
		btn: '[data-expandable-btn]',
		wrapper: '[data-expandable-wrapper]',
	};

	onInit(el) {
		this.onPointerdown = this.onPointerdown.bind(this);
		this.open = this.open.bind(this);
		this.close = this.close.bind(this);

		this.el = el;

		this.btn = this.el.querySelector(Expandable.selectors.btn);
		this.wrapper = this.el.querySelector(Expandable.selectors.wrapper);
		this.elFocusables = getFocusables(this.wrapper);
		this.isOpen = false;

		if (this.wrapper === null || this.btn === null) {
			this.onDestroy();
			return;
		}

		this.slide = new Slide(this.wrapper);
	}

	onReady() {
		emitter.on('product-expandable:open', () => {
			if (this.isOpen) this.close();
		});

		if (this.btn !== void 0) {
			this.btn.addEventListener('click', this.onPointerdown);
		} else {
			this.el.addEventListener('click', this.onPointerdown);
		}

		if (this.wrapper.style.display !== 'none') {
			this.isOpen = true;
			this.btn.setAttribute('aria-expanded', 'true');
			this.toggleAttrInert(true);
		} else {
			this.btn.setAttribute('aria-expanded', 'false');
			this.toggleAttrInert(false);
		}
	}

	onPointerdown() {
		if (!this.isOpen) {
			if (window.location.pathname.startsWith('products', 1)) {
				emitter.emit('product-expandable:open');
			}
			this.open();
		} else {
			this.close();
		}
	}

	open() {
		this.slide.down('easeOutQuart', 50);
		this.isOpen = true;
		this.btn.setAttribute('aria-expanded', 'true');
		this.wrapper.classList.add('is-open');
		this.btn.classList.add('is-open');
		this.toggleAttrInert(true);
	}

	close() {
		this.slide.up('easeOutQuart', 50);
		this.isOpen = false;
		this.btn.setAttribute('aria-expanded', 'false');
		// this.btn.focus();
		this.wrapper.classList.remove('is-open');
		this.btn.classList.remove('is-open');
		this.toggleAttrInert(false);
	}

	toggleAttrInert(state) {
		for (const element of this.elFocusables) {
			if (state) {
				element.removeAttribute('inert');
			} else {
				element.setAttribute('inert', true);
			}
		}
	}
}
